import { cn } from '@/lib/utils'

/**
 * A dim, gently pulsing placeholder block for loading states — the calm Notion
 * alternative to a spinner. Compose a few to mirror the shape of the content
 * that's coming (a title bar, some rows) so the layout doesn't jump when it
 * loads. Pulse is `motion-safe` and also covered by the global reduced-motion
 * guard.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden="true" className={cn('rounded-sm bg-skeleton motion-safe:animate-pulse', className)} />
}
